import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../context/I18nContext';
import { publicApi } from '../api';
import { useApi } from '../hooks/useApi';
import { staticImg } from '../utils/media';
import { ArrowUpRight } from 'lucide-react';

const FALLBACK = {
  discord: 'https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?w=800&auto=format',
  zindanlar: 'https://images.unsplash.com/photo-1460194436988-671f763436b7?w=800&auto=format',
  maplar: 'https://images.pexels.com/photos/12650746/pexels-photo-12650746.jpeg?w=800',
  models: 'https://images.pexels.com/photos/31350033/pexels-photo-31350033.jpeg?w=800',
};

export default function Categories() {
  const { lang } = useI18n();
  const { data } = useApi(() => publicApi.categories(lang), [lang]);
  const items = (data || []).map((c) => ({ ...c, imageUrl: c.image ? staticImg(c.image) : FALLBACK[c.slug] || staticImg(null) }));

  return (
    <section className="relative py-12">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {items.map((c) => (
            <Link key={c.id} to={`/products?category=${c.slug}`} className="group relative overflow-hidden rounded-2xl h-44 md:h-52 border border-white/8 card-hover">
              <img src={c.imageUrl} alt={c.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/45 to-black/25" />
              <div className="relative h-full flex flex-col justify-end p-3 md:p-4">
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <h4 className="font-display text-base md:text-lg font-extrabold text-white group-hover:gold-text transition leading-tight truncate">{c.name}</h4>
                    <div className="text-[10px] tracking-widest text-white/60 mt-1 line-clamp-1">{c.description || '—'}</div>
                  </div>
                  <div className="w-8 h-8 shrink-0 rounded-full bg-[#e4b44e]/15 border border-[#e4b44e]/40 flex items-center justify-center text-[#f4d896] group-hover:bg-[#e4b44e] group-hover:text-[#17140b] transition">
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
